import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Space, Switch } from 'antd';
import Typography from 'antd/es/typography/Typography';
import { Column, Table } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { CategoryFilterFormValuesPaginated } from 'features/master-management/components/filter-field/type';
import { AddClassModal } from 'features/master-management/components/modal/class-master/add-classs-master';
import { useStatusClass } from 'features/master-management/use-cases/class-status-change';
import { useDeleteClass } from 'features/master-management/use-cases/delete-class';
import { usePermissions } from 'features/users';
import { FilePenLine, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categorymaster } from 'types/master';
import { Role } from 'types/role';
// ../../modal/class-master/add-classs-master
type CategoryTableProps = {
  dataList: categorymaster[];
  isFetching: boolean;
  tableParams: CategoryFilterFormValuesPaginated;
  setEditModal: any;
  setEditData: any;
};

export const ClassTableItemView = ({
  dataList,
  isFetching,
  tableParams,
  setEditModal,
  setEditData,
}: CategoryTableProps) => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const { mutate } = useDeleteClass();
  const { mutate: statusClass, isLoading } = useStatusClass();
  const [showAddModal, setShowAddModal] = useState(false);

  if (!permissions) return null;
  const handleOpenModal = (record: any) => {
    setEditModal(true);
    setEditData(record);
  };
  const onChangeDelete = (data: any) => {
    mutate(data.id); // Call mutate with data.id
  };

  return (
    <StyledTableWrapper className='card grid_secton'>
      {/* <StyledTableHeader></StyledTableHeader> */}

      <StyledTableHeader className='gs_head'>
        <h3>
          Class List{' '}
          {/* <span>{dataList?.length > 0 ? dataList[0].totalRecords : '0'}</span> */}
        </h3>

        <div className='buttongroup'>
          <Button
            icon={<PlusCircleOutlined />}
            onClick={() => setShowAddModal(true)}
            style={{ backgroundColor: '#223666', color: 'white' }}
          >
            Add New Class
          </Button>
          {showAddModal && (
            <AddClassModal onClose={() => setShowAddModal(false)} />
          )}
        </div>
      </StyledTableHeader>

      <div className='cstmtblbx'>
        <div className='cstm_table'>
          <Table<categorymaster>
            loading={isFetching}
            dataSource={dataList}
            rowKey='id'
            // onChange={handleTableChange}
            pagination={{
              current: tableParams.PageIndex,
              defaultPageSize: tableParams.RecordPerPage,
              total: 10,
            }}
            // scroll={{ x: 1440 }}
            components={{
              header: {
                cell: (
                  props: React.HTMLAttributes<HTMLTableHeaderCellElement>,
                ) => <th {...props} />,
              },
            }}
          >
            <Column<categorymaster>
              width='125px'
              title={'Sr.No'}
              render={(_, __, index) => index + 1}
            />
            <Column<categorymaster>
              title={'Category Name'}
              dataIndex={'categoryName'}
            />
            <Column<categorymaster>
              title={'Sub Category Name'}
              dataIndex={'subCategoryName'}
            />
            <Column<categorymaster> title={'Class'} dataIndex={'className'} />

            <Column<Role>
              width='125px'
              title={t('usermanagement.table.status')}
              dataIndex={'role'}
              render={(_, record: any) => (
                <Space>
                  <Typography
                    style={{
                      color: record.isActive ? '#155724' : 'red', // Green for "Active", Red for "Inactive"
                    }}
                  >
                    {record.isActive == true ? 'Active' : 'Inactive'}
                  </Typography>
                </Space>
              )}
            />
            <Column<categorymaster>
              width='180px'
              title={t('usermanagement.table.action')}
              dataIndex={'Id'}
              render={(_, record: any) => (
                <Space className='grdbtngroup'>
                  <Button
                    className='btn'
                    type='link'
                    onClick={() => handleOpenModal(record)}
                  >
                    <FilePenLine height={16} />
                  </Button>

                  <Popconfirm
                    title='Delete the Class'
                    description='Are you sure to delete this Class?'
                    onConfirm={() => onChangeDelete(record)}
                    okText='Yes'
                    cancelText='No'
                  >
                    <Button className='btn' type='link'>
                      <Trash2 stroke='#E04343' height={16} />
                    </Button>
                  </Popconfirm>

                  <Switch
                    onClick={() => {
                      statusClass(record.id); // Pass the record.Id to the mutate function
                    }}
                    disabled={isLoading}
                    loading={isLoading}
                    checked={record?.isActive == true}
                  />
                </Space>
              )}
            />
          </Table>
        </div>
      </div>
    </StyledTableWrapper>
  );
};
